module.exports = __webpack_public_path__ + "static/media/solid_file_excel~boHPZPfy.1ac456bf.svg";